var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrioritizationbeneficiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 485 l0 -65 140 0 140 0 0 65 0 65 -140 0 -140 0 0 -65z m248 -2 l-3 -28 -100 0 -100 0 -3 28 -3 27 106 0 106 0 -3 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 530 c0 -5 25 -10 57 -10 53 0 55 -1 40 -18 -29 -32 -57 -106 -57 -155 0 -56 16 -99 54 -145 38 -44 53 -30 17 16 -43 53 -59 119 -43 178 13 49 47 104 63 104 5 0 9 -27 9 -60 0 -33 4 -60 10 -60 6 0 10 33 10 80 l0 80 -80 0 c-47 0 -80 -4 -80 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 310 l0 -60 135 0 135 0 0 60 0 60 -135 0 -135 0 0 -60z m240 5 l0 -35 -110 0 -110 0 0 35 0 35 110 0 110 0 0 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 150 l0 -60 135 0 135 0 0 60 0 60 -135 0 -135 0 0 -60z m240 -5 l0 -35 -110 0 -110 0 0 35 0 35 110 0 110 0 0 -35z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritizationbeneficiary);
export default __webpack_public_path__ + "static/media/prioritizationbeneficiary.80d96ae4eb2094608029f37c481bd4cb.svg";
export { ForwardRef as ReactComponent };